export interface PurchaseOrderLinePreviousOrders {
  id: string;
  purchaseOrderAndLineNo: string;
  dateOrdered: Date;
  orderTypeDescription: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  price: number;
  deliveryDate: Date;
  currencyLineValue: number;
}
